module.exports = __webpack_public_path__ + "static/media/Survivor Bias - karim-manjra-Jwk88nuBMr4-unsplash copy.c6c9a1c9.jpg";